import  { createContext, useContext } from 'react';

type TabSection =
  | 'marketplace'
  | 'finops'
  | 'sts'
  | 'creative'
  | 'finance'
  | 'media'
  | 'dx'
  | 'n8n';

interface TabSectionContextType {
  activeSection: TabSection;
  setActiveSection: (section: TabSection) => void;
}

export const TabSectionContext = createContext<TabSectionContextType>({
  activeSection: 'marketplace',
  setActiveSection: () => {},
});

export const useTabSection = () => useContext(TabSectionContext);
